// @generated by TypeGen from AppBaseWebView/URLNavigation.swift - DO NOT EDIT

export interface IURLNavigationRequest {
  url: string;
  destination: IURLNavigationDestination;
}

export enum IURLNavigationDestination {
  external = "external",
  overlay = "overlay",
}
